// List of popular Ant Design icons to be used in the Button
export const iconOptions = [
  { label: "SearchOutlined", value: "SearchOutlined" },
  { label: "RightOutlined", value: "RightOutlined" },
  { label: "HomeOutlined", value: "HomeOutlined" },
  { label: "UserOutlined", value: "UserOutlined" },
  { label: "SettingOutlined", value: "SettingOutlined" },
  { label: "MailOutlined", value: "MailOutlined" },
  { label: "PlusOutlined", value: "PlusOutlined" },
  { label: "EditOutlined", value: "EditOutlined" },
  { label: "DeleteOutlined", value: "DeleteOutlined" },
  { label: "DownloadOutlined", value: "DownloadOutlined" },
  { label: "UploadOutlined", value: "UploadOutlined" },
  { label: "ArrowUpOutlined", value: "ArrowUpOutlined" },
  { label: "ArrowDownOutlined", value: "ArrowDownOutlined" },
  { label: "ArrowLeftOutlined", value: "ArrowLeftOutlined" },
  { label: "ArrowRightOutlined", value: "ArrowRightOutlined" },
  { label: "CheckOutlined", value: "CheckOutlined" },
  { label: "CloseOutlined", value: "CloseOutlined" },
  { label: "InfoOutlined", value: "InfoOutlined" },
  { label: "WarningOutlined", value: "WarningOutlined" },
  { label: "QuestionOutlined", value: "QuestionOutlined" },
  { label: "ExclamationOutlined", value: "ExclamationOutlined" },
  { label: "EyeOutlined", value: "EyeOutlined" },
  { label: "EyeInvisibleOutlined", value: "EyeInvisibleOutlined" },
  { label: "HeartOutlined", value: "HeartOutlined" },
  { label: "StarOutlined", value: "StarOutlined" },
  { label: "LikeOutlined", value: "LikeOutlined" },
  { label: "DislikeOutlined", value: "DislikeOutlined" },
  { label: "MessageOutlined", value: "MessageOutlined" },
  { label: "BellOutlined", value: "BellOutlined" },
  { label: "CalendarOutlined", value: "CalendarOutlined" },
  { label: "ClockCircleOutlined", value: "ClockCircleOutlined" },
  { label: "FolderOutlined", value: "FolderOutlined" },
  { label: "FileOutlined", value: "FileOutlined" },
  { label: "CameraOutlined", value: "CameraOutlined" },
  { label: "VideoCameraOutlined", value: "VideoCameraOutlined" },
  { label: "PhoneOutlined", value: "PhoneOutlined" },
  { label: "TabletOutlined", value: "TabletOutlined" },
  { label: "DesktopOutlined", value: "DesktopOutlined" },
  { label: "LaptopOutlined", value: "LaptopOutlined" },
  { label: "CarOutlined", value: "CarOutlined" },
  { label: "ShopOutlined", value: "ShopOutlined" },
  { label: "ShoppingCartOutlined", value: "ShoppingCartOutlined" },
  { label: "CreditCardOutlined", value: "CreditCardOutlined" },
  { label: "GiftOutlined", value: "GiftOutlined" },
  { label: "TagOutlined", value: "TagOutlined" },
  { label: "WalletOutlined", value: "WalletOutlined" },
  { label: "TrophyOutlined", value: "TrophyOutlined" },
  { label: "CrownOutlined", value: "CrownOutlined" },
  { label: "FlagOutlined", value: "FlagOutlined" },
  { label: "FireOutlined", value: "FireOutlined" },
  { label: "ThunderboltOutlined", value: "ThunderboltOutlined" },
  { label: "BulbOutlined", value: "BulbOutlined" },
  { label: "RocketOutlined", value: "RocketOutlined" },
  { label: "CloudOutlined", value: "CloudOutlined" },
  { label: "CloudDownloadOutlined", value: "CloudDownloadOutlined" },
  { label: "CloudUploadOutlined", value: "CloudUploadOutlined" },
  { label: "CloudSyncOutlined", value: "CloudSyncOutlined" },
  { label: "AppstoreOutlined", value: "AppstoreOutlined" },
  { label: "AppleOutlined", value: "AppleOutlined" },
  { label: "AndroidOutlined", value: "AndroidOutlined" },
  { label: "WindowsOutlined", value: "WindowsOutlined" },
  { label: "GithubOutlined", value: "GithubOutlined" },
  { label: "GitlabOutlined", value: "GitlabOutlined" },
  { label: "GoogleOutlined", value: "GoogleOutlined" },
  { label: "FacebookOutlined", value: "FacebookOutlined" },
  { label: "FacebookFilled", value: "FacebookFilled" },
  { label: "TwitterOutlined", value: "TwitterOutlined" },
  { label: "XOutlined", value: "XOutlined" },
  { label: "LinkedinOutlined", value: "LinkedinOutlined" },
  { label: "LinkedinFilled", value: "LinkedinFilled" },
  { label: "InstagramOutlined", value: "InstagramOutlined" },
  { label: "YoutubeOutlined", value: "YoutubeOutlined" },
  { label: "RedditOutlined", value: "RedditOutlined" },
  { label: "SlackOutlined", value: "SlackOutlined" },
  { label: "SkypeOutlined", value: "SkypeOutlined" },
  { label: "WhatsAppOutlined", value: "WhatsAppOutlined" },
  { label: "WeChatOutlined", value: "WeChatOutlined" },
  { label: "DribbbleOutlined", value: "DribbbleOutlined" },
  { label: "BehanceOutlined", value: "BehanceOutlined" },
  { label: "MediumOutlined", value: "MediumOutlined" },
  { label: "PinterestOutlined", value: "PinterestOutlined" },
  { label: "VimeoOutlined", value: "VimeoOutlined" },
  { label: "FlickrOutlined", value: "FlickrOutlined" },
  { label: "DropboxOutlined", value: "DropboxOutlined" },
  { label: "AmazonOutlined", value: "AmazonOutlined" },
  { label: "YahooOutlined", value: "YahooOutlined" },
  { label: "MicrosoftOutlined", value: "MicrosoftOutlined" },
  { label: "SlackSquareOutlined", value: "SlackSquareOutlined" },
  { label: "SkypeSquareOutlined", value: "SkypeSquareOutlined" },
  { label: "WhatsAppSquareOutlined", value: "WhatsAppSquareOutlined" },
  { label: "WeChatSquareOutlined", value: "WeChatSquareOutlined" },
  { label: "DribbbleSquareOutlined", value: "DribbbleSquareOutlined" },
  { label: "BehanceSquareOutlined", value: "BehanceSquareOutlined" },
  { label: "MediumSquareOutlined", value: "MediumSquareOutlined" },
  { label: "PinterestSquareOutlined", value: "PinterestSquareOutlined" },
  { label: "VimeoSquareOutlined", value: "VimeoSquareOutlined" },
  { label: "FlickrSquareOutlined", value: "FlickrSquareOutlined" },
  { label: "DropboxSquareOutlined", value: "DropboxSquareOutlined" },
  { label: "AmazonSquareOutlined", value: "AmazonSquareOutlined" },
  { label: "YahooSquareOutlined", value: "YahooSquareOutlined" },
  { label: "MicrosoftSquareOutlined", value: "MicrosoftSquareOutlined" },
  { label: "DownOutlined", value: "DownOutlined" },
]
